"use client"

import { motion } from "motion/react"

type ValuesItem = {
  title: string;
  description: string;
  icon?: string;
};

export type ValuesProps = {
  uptitle: string;
  title: string;
  valuesItems: ValuesItem[];
};

export const Values = ({
    uptitle,
    title,
    valuesItems
  }: ValuesProps) => {
    const containerVariants = {
        hidden: {},
        show: {
          transition: {
            staggerChildren: 0.15,
          },
        },
      };
    
      const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { ease: "easeOut" as const, duration: 1 } },
      };
    return (
        <div className="max-w-full overflow-x-hidden bg-[#0A3043] py-36">
        <div className="mx-auto max-w-2xl px-6 text-center">
          <h4 className={`text-sm text-[#193143]`}>{uptitle}</h4>
          <h2 className="mt-2 text-balance text-2xl tracking-normal text-white sm:text-3xl">
            {title}
          </h2>
        </div>
        <div className="mx-auto max-w-6xl px-6 text-center justify-start">
          <motion.div
            className="grid grid-cols-1 gap-x-4 gap-y-3 my-6 lg:gap-y-4 lg:grid-cols-4 sm:mt-16 sm:mb-14 text-left justify-start"
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
          >
            {valuesItems.map((item: ValuesItem) =>
              <motion.div
                key={item.title}
                variants={itemVariants}
                className={`border-solid border-2 border-gray-200 rounded-lg text-center justify-start ${item.icon ? "pt-8 pb-12 px-7" : "py-7"}`}
              >
                <div className={`${item.icon ? 'mt-5' : 'mt-3 px-7'}`}>
                  <h4 className='tracking-normal text-xl sm:text-xl text-white'>
                    {item.title}
                  </h4>
                  <p className={'leading-6 text-sm text-white mt-6'}>
                    {item.description}
                  </p>
                </div>
              </motion.div>
            )}
          </motion.div>
        </div>
      </div>
    );
  };

